<template>
  <span class=" bg-white  rounded-full p-[3px]">
 
  <svg xmlns="http://www.w3.org/2000/svg" width="13.338" height="13.8" viewBox="0 0 13.338 13.8">
    <g id="Group_605" data-name="Group 605" transform="translate(0.9 1.208)">
      <line
        id="Line_45"
        data-name="Line 45"
        y2="12"
        transform="translate(5.539 -0.308)"
        fill="none"
        stroke="#0963ff"
        stroke-linecap="round"
        stroke-width="1.8" />
      <line
        id="Line_46"
        data-name="Line 46"
        y2="11.538"
        transform="translate(11.538 5.769) rotate(90)"
        fill="none"
        stroke="#0963ff"
        stroke-linecap="round"
        stroke-width="1.8" />
    </g>
  </svg>
</span>
</template>
